<template>
  <component
    :is="modelValue ? 'label' : 'div'"
    :class="['cf-gift-card', {
      'cf-gift-card--details': type === 'details',
      'cf-gift-card--radio': type === 'radio-button'
    }]"
    :style="cardDesign.url ? `background-image: url(${ cardDesign.url })` : 'background-color: var(--color-brand-primary)'"
  >
    <template v-if="modelValue">
      <div
        v-if="modelValue === cardDesignId"
        class="cf-gift-card--radio__checkmark"
      >
        <span class="cf-icon fa-check" />
      </div>

      <input
        :id="`card-design-option-${cardDesignId}`"
        v-model="val"
        :checked="modelValue === cardDesignId"
        class="cf-gift-card__input"
        type="radio"
        name="card-design-option"
        :value="cardDesignId"
      >
    </template>

    <div
      v-if="cardAmount !== null"
      class="cf-gift-card__amount"
    >
      <h1 :class="['cf-title cf-title--2', cardAmount ? 'cf-title--brand-primary' : 'cf-title--gray']">
        {{ cardAmountDisplay }}
      </h1>
    </div>
  </component>
</template>


<script>
  import dollars from '@/filters/dollars';


  export default {
    name: 'CfGiftCard',

    props: {
      cardDesign: {
        type: Object,
        default: () => ({})
      },

      cardAmount: {
        type: Number,
        default: null
      },

      type: {
        type: String,
        default: 'details'
      },

      modelValue: {
        type: Number,
        default: undefined
      }
    },

    computed: {
      cardDesignId() {
        return this.cardDesign.id;
      },

      cardAmountDisplay() {
        return dollars(this.cardAmount);
      },

      val: {
        get() {
          return this.modelValue;
        },

        set(newValue) {
          this.$emit('update:modelValue', newValue);
        }
      }
    }
  };
</script>
